import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, euro, errMsg } from "@/lib/api";
import { RefundBox } from "./RefundBox";

const PAY = { paid: "Payée", pending: "En attente", payment_processing: "Paiement en cours", expired: "Expirée", failed: "Échouée", cancelled: "Annulée", refunded: "Remboursée", partially_refunded: "Partiellement remboursée" };
const MAIL = { sent: "Email envoyé", sending: "Envoi…", failed: "Email cliente non envoyé — appelez-la", no_email: "Pas d'email" };
const METHOD = { monetico: "CB · CIC Monetico", paypal: "PayPal", stripe: "Stripe", reservation: "Virement — à encaisser" };

export function PayCell({ o, onDone }) {
  const [busy, setBusy] = useState(false);
  const markPaid = async () => {
    if (!window.confirm(`Confirmer la réception du virement de ${euro(o.amount)} (réf. ${o.reference}) de ${o.customer_name || "la cliente"} ? La commande passera en « payée » et un email de confirmation lui sera envoyé.`)) return;
    setBusy(true);
    try {
      await api.post(`/admin/orders/${o.id}/mark-paid`);
      toast.success("Virement reçu — commande payée");
      onDone?.();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid={`admin-order-pay-${o.id}`} className="space-y-1">
      <span data-testid={`admin-order-pay-status-${o.id}`} className={o.payment_status === "paid" ? "text-emerald-400" : o.payment_status === "refunded" ? "text-sky-300" : "text-[var(--muted)]"}>{PAY[o.payment_status] || o.payment_status}</span>
      <span data-testid={`admin-order-pay-method-${o.id}`} className="block text-xs text-[var(--parchment)]/80">{METHOD[o.payment_method] || METHOD.stripe}</span>
      {o.transaction_id ? <span data-testid={`admin-order-txn-${o.id}`} className="block break-all text-xs text-[var(--muted)]">Transaction : {o.transaction_id}</span> : null}
      {o.paid_at ? <span className="block text-xs text-[var(--muted)]">Payée le {new Date(o.paid_at).toLocaleString("fr-FR")}</span> : null}
      {o.amount_paid != null ? <span data-testid={`admin-order-amount-paid-${o.id}`} className="block text-xs text-[var(--muted)]">Montant payé : {euro(o.amount_paid)}</span> : null}
      {o.payment_error ? <span data-testid={`admin-order-pay-error-${o.id}`} className="block text-xs text-red-300">{o.payment_error}</span> : null}
      {o.refunded_at ? <span className="block text-xs text-sky-300">Remboursée le {new Date(o.refunded_at).toLocaleString("fr-FR")}</span> : null}
      {o.email_status ? <span data-testid={`admin-order-email-${o.id}`} className={`block text-xs ${o.email_status === "sent" ? "text-[var(--gold-soft)]" : o.email_status === "failed" ? "font-semibold text-red-300" : "text-[var(--muted)]"}`}>{MAIL[o.email_status] || o.email_status}</span> : null}
      {o.payment_method === "reservation" && ["pending", "payment_processing"].includes(o.payment_status) ? (
        <span data-testid={`admin-order-deadline-${o.id}`} className="block text-xs text-[var(--parchment)]/80">
          À payer avant le {new Date(new Date(o.created_at).getTime() + 3 * 864e5).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}
          {o.reminder_status === "sent" ? " · Rappel envoyé" : ""}
        </span>
      ) : null}
      {o.payment_method === "reservation" && (["pending", "payment_processing"].includes(o.payment_status) || (o.reservation_expired && o.payment_status === "cancelled")) ? (
        <button data-testid={`admin-order-mark-paid-${o.id}`} disabled={busy} onClick={markPaid} className="mt-1 flex items-center gap-1 rounded-full bg-[var(--gold)] px-3 py-1 text-xs font-semibold text-[var(--ink)] disabled:opacity-50">
          {busy && <Loader2 className="h-3 w-3 animate-spin" />} Virement reçu
        </button>
      ) : null}
      <RefundBox o={o} onDone={onDone} />
    </div>
  );
}
